<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeDialog"
    width="1000px"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <el-table
      v-loading="loading"
      :data="List"
      border
      stripe
      :highlight-current-row="true"
    >
      <el-table-column prop="File_Name" :label="$t('TankService.FileName')" min-width="200" />
      <el-table-column prop="File_Type" :label="$t('TankService.FileType')" min-width="200" />
      <el-table-column prop="File_Url" :label="$t('TankService.Operation')" width="100">
        <template slot-scope="scope">
          <div>
            <el-button
              type="text"
              size="small"
              style="color: red"
              @click="dfLoad(scope.row)"
            >
              {{ $t('TankService.Download') }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button type="crud" @click="closeDialog">{{ $t('TankService.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import GMS_TANKFILE from '@/assets/json/gmsTankFile.json'
import dialog from '@/components/fms/mixins/dialog';
import { convertYMD } from '@/utils/index.js';
import { getFileListByBookingNo, getTDFileListByBookingNo, getFileListByYardScheduleID, getFileBlob } from '@/api//gmsTank.js';
import { ISStr } from '@/utils/isClass';
export default {
  components: {},
  mixins: [dialog],
  props: {
    curRow: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      lang: 'zh',
      loading: false,
      List: [],
    };
  },
  computed: {},
  mounted() {
    this.lang = this.$ls.get('lang');
    this.load();
  },
  methods: {
    async load()
    {
      const data = {
        BookingNo: this.curRow.Booking_No,
        lang: this.lang
      };
      this.loading = true;
      var res = [];
      if (this.curRow.Job_Type === 'TE') {
        res = await getFileListByBookingNo(data);
      }
      if (this.curRow.Job_Type === 'TD') {
        res = await getTDFileListByBookingNo(data);
      }
      if (this.curRow.Job_Type === 'TY') {
        const data = {
          YardScheduleID: this.curRow.YardScheduleID,
          lang: this.lang
        };
        res = await getFileListByYardScheduleID(data);
      }
      this.loading = false;
      if (res && res.isSuccess)
      {
        this.List = res.data;
      }
    },
    formatterTime(row, column) {
      return convertYMD(row[column.property]);
    },
    dfLoad(row) {
      getFileBlob({ Url: row.File_Url, lang: this.lang }).then((res) => {
        if (!ISStr(res.data)) {
          var fileContent = res.data; // 从后端获取的 byte[] 转换成的字符串
          // 将字符串转换为 byte[]
          var byteCharacters = atob(fileContent);
          var byteArray = new Uint8Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteArray[i] = byteCharacters.charCodeAt(i);
          }
          // 创建 Blob 对象
          var blob = new Blob([byteArray], {
            type: 'application/octet-stream',
          });
          this.DownloadItem(blob, row.File_Name);
        } else {
          // 获取文件地址信息失败，打开新页面显示附件
          const link = document.createElement('a');
          link.href = row.File_Url;
          link.download = row.File_Name;
          link.target = '_blank';
          link.click();
        }
      });
    },
    getBlob(url) {
      return new Promise((resolve) => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            const reader = new FileReader();
            reader.onload = (event) => {
              try {
                const content = this.decodeUnicode(
                  JSON.parse(event.target.result)
                );
                if (content.isSuccess === false) {
                  this.messagebox.alert(content.msg);
                } else {
                  resolve(xhr.response);
                }
              } catch (error) {
                resolve(xhr.response);
              }
            };
            reader.readAsText(xhr.response);
          }
        };
        xhr.onerror = () => {
          console.log('请求异常：' + xhr.statusText);
        };
        xhr.send();
      });
    },
    DownloadItem(blob, fileName) {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    decodeUnicode(obj) {
      for (var key in obj) {
        if (typeof obj[key] === 'string') {
          obj[key] = unescape(obj[key].replace(/\\u/g, '%u'));
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
          this.decodeUnicode(obj[key]);
        }
      }
      return obj;
    },
  },
};
</script>
    <style scoped>
</style>
